export const baseURL = "https://livefix.skhlive.fun/";
export const key = "L0]?/7Wf=[VS}L@FKk`_#^pnd]:v@M";
